'use client';

import React from 'react';
import { cn } from '@/lib/utils';

interface PlanSkeletonProps {
  count?: number;
  className?: string;
}

export default function PlanSkeleton({ count = 3, className }: PlanSkeletonProps) {
  return (
    <div className={cn("grid grid-cols-1 lg:grid-cols-2 gap-4", className)}>
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="glass rounded-2xl p-5 card-pattern flex flex-col gap-4 relative overflow-hidden h-full min-h-[220px]"
        >
          {/* Shimmer effect */}
          <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/5 to-transparent" />
          
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-2">
              <div className="h-4 w-6 bg-muted rounded-[2px]" />
              <div className="h-4 w-24 bg-muted rounded" />
            </div>
          </div>

          <div className="flex items-start justify-between gap-3">
            <div className="space-y-3 flex-1">
              <div className="h-6 w-3/4 bg-muted rounded" />
              <div className="h-4 w-1/2 bg-muted rounded" />
              <div className="flex gap-2">
                <div className="h-5 w-16 bg-muted rounded-full" />
                <div className="h-5 w-20 bg-muted rounded-full" />
              </div>
            </div>
            <div className="text-right flex flex-col items-end gap-1">
              <div className="h-8 w-16 bg-muted rounded" />
              <div className="h-3 w-12 bg-muted rounded" />
            </div>
          </div>

          <div className="mt-auto flex gap-2">
            <div className="h-10 flex-1 bg-muted rounded-md" />
            <div className="h-10 w-12 bg-muted rounded-md" />
          </div>
        </div>
      ))}
    </div>
  );
}
